import MappingOrigin from "./mappingOrigin";
import Form from "../../../formability/form_builder/models/form";
import FormElement from "../../../formability/form_builder/models/formElements/formElement";
import {FormElementType} from "../../enums/formElementType";
import {ModelType} from "~/enums/modelType";
import OriginWrapperForm from "~/models/mapping/originWrapperForm";
import MappingOriginOptionForm from "~/models/mapping/mappingOriginOptionForm";
import MappingOriginOptionFormElement from "~/models/mapping/mappingOriginOptionFormElement";
import OriginWrapperFormElementHelper from "~/models/mapping/originWrapperHelpers/originWrapperFormElementHelper";
import OriginWrapperPaymentStep from "~/models/mapping/originWrapperPaymentStep";
import MappingOriginOptionPaymentStep from "~/models/mapping/mappingOriginOptionPaymentStep";
import OriginWrapperPaymentStepLineItem from "~/models/mapping/originWrapperPaymentStepLineItem";
import MappingOriginOptionPaymentStepLineItem from "~/models/mapping/mappingOriginOptionPaymentStepLineItem";

export default class MappingOriginForm extends MappingOrigin {
  readonly friendly_type = ModelType.Form;

  root_client_id: string;
  model_client_ids: string[];

  get rootIdentifier(): string {
    return this.root_client_id;
  }

  set rootIdentifier(value) {
    this.root_client_id = value;
  }

  get modelIdentifiers() {
    return this.model_client_ids || [];
  }

  set modelIdentifiers(value) {
    this.model_client_ids = value;
  }

  get root() {
    return new OriginWrapperForm(Form.repo.find(this.root_client_id));
  }

  get relationshipModels() {
    const modelClientIds = this.modelIdentifiers;

    const elementOriginWrappers = FormElement.repo.all()
      .filter(formElement => modelClientIds.includes(formElement.client_id))
      .map(OriginWrapperFormElementHelper.build)

    const stepOriginWrappers = []
    this.root.object.paymentSteps
      .forEach(step => {
        if (modelClientIds.includes(step.client_id)) {
          // for the overall payment information
          stepOriginWrappers.push(new OriginWrapperPaymentStep(step))
        }
        if (modelClientIds.includes(OriginWrapperPaymentStepLineItem.addSuffix(step.client_id))) {
          // for the repeatable that represents every payment line item
          stepOriginWrappers.push(new OriginWrapperPaymentStepLineItem(step))
        }
      })

    return [
      ...elementOriginWrappers,
      ...stepOriginWrappers,
    ]
  }

  get availableOptions(): (MappingOriginOptionForm | MappingOriginOptionFormElement)[] {
    return MappingOriginForm.availableOptions(this.root.object);
  }

  static availableOptions(form: Form): (MappingOriginOptionForm | MappingOriginOptionFormElement)[] {
    if (!(form instanceof Form)) { return []; }

    let formSources: MappingOriginOptionForm[] = [new MappingOriginOptionForm({origin: form})];

    let elementSources: MappingOriginOptionFormElement[] = [];
    form.workflowStepsArray.forEach(workflowStep => {
      if (!workflowStep.form_section) return;
      workflowStep.form_section.formElementsArrayDeep.forEach(formElement => {
        // Eventually have to modify this to handle lookupFields that can be multiple. I.E. object model stuff
        if (formElement.is_repeatable || formElement.element_type === FormElementType.lookupField) {
          const type = formElement.is_repeatable ? 'multi' : 'single';
          elementSources.push(new MappingOriginOptionFormElement({origin: formElement, type: type}))
        }
      })
    });

    const stepSources: MappingOriginOptionPaymentStep[] = []
    form.paymentSteps.forEach(step => {
      stepSources.push(new MappingOriginOptionPaymentStep({origin: step, type: 'single'}))
      stepSources.push(new MappingOriginOptionPaymentStepLineItem({origin: step, type: 'multi'}))
    })

    return [].concat(formSources, elementSources, stepSources)
  }
}
